<ion-header class="ion-no-border">
  <ion-toolbar class="Recovery-trac-header Recovery-trac-header1">
    <ion-title>PRIVACY & SECURITY</ion-title>
    <span  (click)="closePrivacy()" class="close_icon">
      <ion-icon size="large" name="close-outline"></ion-icon>
    </span>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-grid class="pa30">
    <ion-row>
      <ion-col>
        <p  class="logtxt">
          1.1 <span class="tab"><u>Information Collected.</u></span> The types of information that Tetra Tech and its
          suppliers collect includes both
          personally identifiable information and non-personally identifiable information.
        </p>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <p class="logSubtxt">
          <span class="tab"></span>(a) <span class="tab"></span>Personally-identifiable information refers to
          information which can be used to specifically identify You
          as an individual (e.g., name, username, telephone number, mobile number, and work email address). You may
          also provide Tetra Tech and its suppliers information about Your governmental entity, business and business
          activities, including financial information such as Your payment methods, purchasing volumes, and products
          considered or purchased.
        </p>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <p class="logSubtxt">
          <span class="tab"></span>(b) <span class="tab"></span>Non-personally-identifiable information consists of
          information that does not reveal Your identity and
          may include data associated with Your particular computer or device (e.g. mobile device ID, IP address, GPS
          data, operating system, network interface address).
        </p>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <p class="logtxt">
          1.2 <span class="tab"><u>Collection Technologies.</u></span> Tetra Tech and its suppliers may use various
          technologies to collect
          information
          from Your computer or device and about Your activities related to the Software Product, including but not
          limited to:
        </p>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col class="logSubtxt">
        <p>
          <span class="tab"></span>(a) <span class="tab"></span>Automatically collected information when You use the
          Software Product or visit the Tetra Tech website
          could include for example, Your device ID, IP address, GPS data, browser type and language, and access
          times;
        </p>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col class="logSubtxt">
        <p>
          <span class="tab"></span>(b) <span class="tab"></span>Automatic and continuous authentication requests from
          the Software Product to ensure that use of the
          Software Product is authorized.
        </p>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col class="logSubtxt">
        <p>
          <span class="tab"></span>(c) <span class="tab"></span>Incident-based crash reports from the Software
          Product, including a minidump of the crashed Software
          Product;
        </p>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col class="logSubtxt">
        <p>
          <span class="tab"></span>(d) <span class="tab"></span>We may send You notifications regarding the Software
          Product, notifying You of new products, or for
          service-related matters. Tetra Tech or its partners and affiliates may also send You messages regarding
          topics that Tetra Tech believes may be of interest to You. Acceptance of such notifications is a condition
          of using the Software Product.
        </p>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <p class="logtxt">
          1.3 <span class="tab"><u>Use of Collection Information.</u></span> Information collected may be used to: (a)
          manage Your accounts and
          provide customer support, (b) deliver Tetra Tech services and manage its business, (c) facilitate quality
          control measures based solely on incident-based crash reports, (d) enforce or exercise any rights in this
          EULA, (e) ensure that use of the Software Product is authorized; (f) perform functions as otherwise
          described to You at the time of collection; (g) perform any and all functions within Tetra Tech’s ordinary
          course of business; and (h) comply with any legal requirements or obligations. In all circumstances, Tetra
          Tech may perform these functions directly or use a third-party supplier to perform these functions on Tetra
          Tech’s behalf.
        </p>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <p class="logtxt">
          1.4 <span class="tab"><u>Sharing of Information.</u></span> Tetra Tech may also share Your personal or
          non-personal information with others,
          for example:
        </p>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <p class="logSubtxt">
          <span class="tab"></span>(a) <span class="tab"></span>We may disclose personal or non-personal information
          You provide if required to do so by law, at the
          request of a third-party, or if we, in our sole discretion, believe that disclosure is reasonable to: (1)
          comply with the law, requests or orders from law enforcement, or any legal process (whether or not such
          disclosure is required by applicable law); (2) protect or defend Tetra Tech’s rights or property; or (3)
          protect someone’s health or safety.
        </p>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <p class="logSubtxt">
          <span class="tab"></span>(b) <span class="tab"></span>Tetra Tech may disclose Your personal or non-personal
          information where appropriate to enforce the terms
          and conditions of this EULA or other Tetra Tech policies.
        </p>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <p class="logtxt">
          1.5 <span class="tab"><u>No Third-Party Rights.</u></span> This EULA does not create rights
          enforceable by third-parties.
        </p>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <p class="logtxt">
          1.6 <span class="tab"><u>Retention of Information.</u></span> Following the termination of this EULA, Tetra
          Tech may retain personal
          information in order to comply with applicable laws, keep accurate records, resolve disputes, prevent fraud,
          enforce this EULA, or for any other legally permissible purpose.
        </p>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <p class="logtxt">
          1.7 <span class="tab"><u>Security.</u></span> Tetra Tech leverages end-to-end encryption including encrypted
          data-at-rest. Access to data is
          limited only to authorized IT personnel or staff with need-to-know access. Access to data is scoped only to
          users with required access to specific data elements.
        </p>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <p class="logtxt">
          1.8 <span class="tab"><u>Location Data.</u></span> This app uses location data to capture coordinates for forms 
          and to report the position of clocked-in users even when the app is closed or not in use.
        </p>
      </ion-col>
    </ion-row>
  </ion-grid>

  <app-footer-buttons-spacer *ngIf="!isPrivacyAccepted"></app-footer-buttons-spacer>
</ion-content>

<app-footer-buttons
    [leftButton]="{
      text: 'I Decline',
      hidden: isPrivacyAccepted
    }"
    [rightButton]="{
      text: 'I Agree',
      hidden: isPrivacyAccepted
    }"
    (leftButtonClicked)="closePrivacy()"
    (rightButtonClicked)="acceptPrivacy()"
></app-footer-buttons>